<template>
  <b-modal
    id="college-event-details-modal"
    ref="modal"
    class="large-modal"
    size="lg"
  >
    <template #modal-header>
      <div v-if="event" class="upper">
        <label>Event Details</label>
        <div class="new-title">
          {{ event.topic }}
        </div>
      </div>
      <button
        class="close"
        @click="hide()"
      >
        ×
      </button>
    </template>
    <div v-if="event">
      <p v-if="event.endsOnDifferentDay" class="date">
        {{ event.start_time | date }} - {{ event.end_time | date }}
      </p>
      <p v-else class="date">
        {{ event.start_time | date }} - {{ event.end_time | timeOnly }}
      </p>

      <p v-if="event.host && event.host.first_name">
        Host: {{ event.host.first_name }} {{ event.host.last_name }}
      </p>

      <p>
        Location: {{ event.in_person_location || 'Online' }}
      </p>

      <ul class="pills">
        <li v-if="event.joined">Joined!</li>
        <li v-else-if="event.user_limit">{{ event.num_spots_left }} Spot<span v-if="event.num_spots_left !== 1">s</span> Left!</li>
      </ul>

      <div v-if="event.description">
        <hr>
        <b class="d-block mt-2 mb-2">Description</b>
        <p class="description">
          {{ event.description }}
        </p>
      </div>

      <div v-if="event.struggle_areas.length">
        <hr>
        <b class="d-block mt-2 mb-2">Topics:</b>
        <ul
          class="table bm-table"
        >
          <li v-for="struggle in event.struggle_areas">
            {{ struggle.name }}
          </li>
        </ul>
      </div>
      <hr>
      <h6>Event Cost - <span v-if="event.cost">{{ event.cost/100 | currency }}</span> <span v-else>FREE</span></h6>
    </div>

    <template
      slot="modal-footer"
      slot-scope="{ ok, cancel }"
    >
      <button
        class="btn"
        type="button"
        @click="hide()"
      >
        Dismiss
      </button>

      <button
        v-if="$store.getters.currentUser.canAddEvents && !event.users_currently_attending"
        type="button"
        class="btn btn--secondary"
        @click="deleteEvent(event)"
      >
        Delete Event
      </button>

      <a
        v-if="event && (event.joined || $store.getters.currentUser.canAddEvents) && event.meeting_start_url"
        :href="event.meeting_start_url"
        target="_blank"
        class="btn btn--primary"
      >
        <span v-if="event.is_meeting_host">Start Event</span>
        <span v-else>Join Event</span>
      </a>
      <button
        v-if="event && !event.joined && event.canJoin && $store.getters.currentUser.isStudent"
        class="btn btn--primary"
        type="button"
        :disabled="saving"
        @click="save()"
      >
        <font-awesome-icon
          v-if="saving"
          :spin="true"
          :icon="['fas', 'spinner']"
          class="icon alt"
        />
        <span v-else>Reserve My Spot</span>
      </button>
      <button
        v-if="event && viewAttendees && $store.getters.currentUser.canAddEvents"
        class="btn btn--primary"
        type="button"
        @click="viewAttendees()"
      >
        View Attendees
      </button>
    </template>
  </b-modal>
</template>

<script>
import StudentClient from '@/api/StudentClient';

export default {
  name: 'EventDetailsModal',
  components: {

  },
  props: {
    updateEventsList: {
      type: Function,
    },
    deleteEvent: {
      type: Function,
    },
    viewAttendees: {
      type: Function,
    },
  },
  data() {
    return {
      studentClient: new StudentClient(this.$http),
      saving: false,
      event: null,
    };
  },
  methods: {
    show(event) {
      this.saving = false;
      this.event = event;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },

    save() {
      if (this.event.cost && this.$store.getters.currentUser.num_pending_payments > 0) {
        return this.$store.commit('setGlobalAlert', {
          msg: 'To schedule a session you must first complete your pending payments.', error: true,
        });
      }

      this.saving = true;
      this.studentClient.joinGroupEvent(this.event.id).then(() => {
        this.saving = false;
        this.hide();
        return this.$store.commit('setGlobalAlert', {
          msg: 'Event Joined!'
        });
        this.updateEventsList();
      }).catch(() => {
        this.saving = false;

        return this.$store.commit('setGlobalAlert', {
          msg: 'Failed to join event. Please try again!', error: true,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#college-event-details-modal {
  .upper {
    display: block;
    position: relative;
    padding-right: 30px;
  }

  label {
    @include label;

    display: block;
    margin-bottom: 10px;
  }

  .date {
    font-size: 18px;
    color: rgba(white, 0.75);
  }

  .pills {
    margin-top: 20px;
  }

  .new-title {
    display: block;
    color: white;
    font-size: 30px;
    font-weight: 700;
    font-family: "Playfair Display", serif;
    line-height: 1;
    text-transform: capitalize;
  }

  .description {
    opacity: 0.76;
  }

  h6 {
    font-weight: normal !important;
    font-size: 25px;
    margin-top: 30px;
    margin-bottom: 10px;

    span {
      font-weight: bold !important;
    }
  }

  .green {
    font-size: 13px;
    color: $green;
  }

  .text-btn {
    border: none;
    background: none;
    color: $red;
    padding: 0;
    outline: none;
    height: auto;
    font-weight: normal;
    margin-top: 25px;
    text-align: right;
    text-transform: none;
    opacity: 0.75;

    &:hover,
    &:focus {
      opacity: 1;
      text-decoration: underline;
    }
  }
}
</style>
